import { render, staticRenderFns } from "./LiquidityRiskAssessmentCard.vue?vue&type=template&id=5b265ead&scoped=true"
import script from "./LiquidityRiskAssessmentCard.vue?vue&type=script&lang=js"
export * from "./LiquidityRiskAssessmentCard.vue?vue&type=script&lang=js"
import style0 from "./LiquidityRiskAssessmentCard.vue?vue&type=style&index=0&id=5b265ead&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b265ead",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLazy } from 'vuetify/lib/components/VLazy';
installComponents(component, {VLazy})
